<icz-essl-object-detail
  [waiting]="loadingService.isLoading$(this) | async"
  [objectNameGeneratorFn]="fileNameGeneratorFn"
  [baseUrlPrefixParts]="baseUrlPrefixParts"
  [defaultTabRoute]="FileDetailRoute.CONTENT"
>
  <icz-file-detail-toolbar
    toolbar
    [spinnerDiameter]="40"
    [waiting]="loadingService.isLoading$(fileDetailService) | async"
    [runningActivity]="fileDetailService.runningActivity$ | async"
    [refActivity]="fileDetailService.refActivity$ | async"
    [refTask]="fileDetailService.refTask$ | async"
    [isRegistryOfficeTransferActivityView]="(fileDetailService.isRegistryOfficeTransferActivityView$ | async)!"
  ></icz-file-detail-toolbar>
  <router-outlet class="router-outlet-block-container"></router-outlet>
</icz-essl-object-detail>
